<template>
  <v-card>
    <v-toolbar>
      <v-toolbar-title class="flex flex-align-center">
        Оценки
        <v-select v-model="sortComment" :items="sortVariant" item-text="name" item-value="id" label="Сортировка"
          single-line dense />
      </v-toolbar-title>
    </v-toolbar>
    <template v-if="sortedBankInfo.length > 0">
      <div class="comment__block" v-for="(bank, index) in sortedBankInfo" :key="index">
        <div>
          <ReteBlock v-if="checkRole(roleObj.bankir)" removeBtnText='Удалить оценку' :rate='bank.rate'
            :title='`${bank.comment.user.name} ${moment(bank.date).format("DD.MM.YYYY")}`' :btnShow='true'
            :avarege='CalculateAvaregeRate(bank.rate)' :makeRate='false' @clearRate='removeBankRate(bank)' />
          <ReteBlock v-else :rate='bank.rate'
            :title='`${bank.comment.user.name} ${moment(bank.date).format("DD.MM.YYYY")}`'
            :avarege='CalculateAvaregeRate(bank.rate)' :makeRate='false' />
          <GoodOrBad :goodOrBad="bank.comment.goodOrBad" />
          <Recommend :value="toBoolean(bank.comment.recommend)" :readonly="true" />
        </div>
        <div class="comment pr-8">
          <v-textarea label="Плюсы" outlined rows="4" row-height="30" no-resize shaped :value="bank.comment.good" readonly
            v-if='bank.comment.good' />
          <v-textarea label="Минусы" outlined rows="4" row-height="30" no-resize shaped :value="bank.comment.bad"
            v-if="bank.comment.bad" readonly />
          <v-textarea label="Комментарий" outlined rows="4" row-height="30" no-resize shaped :value="bank.comment.comment"
            readonly />
          <Likes :bank_id='bank_id' :product_id='product_id' :user_id='bank.comment.user.id'
            :likes='bank.comment.likes.likesCount ? bank.comment.likes.likesCount : 0'
            :likesArray='bank.comment.likes.likes' :useful='bank.comment.likes.useful'
            :dislikes='bank.comment.likes.dislikesCount ? bank.comment.likes.dislikesCount : 0'
            :dislikesArray='bank.comment.likes.dislikes' @makeInit='init' />
        </div>

      </div>
    </template>
    <template v-else>
      <div class="pt-8 pl-8 pr-8 pb-3">
        <p class="text-center" style="width: 100%">Пока нет рейтинга и комментариев по данному продукту</p>
      </div>
    </template>
  </v-card>
</template>
<script>
import moment from "moment";
import Likes from './Likes.vue'
import ReteBlock from './rateBlock.vue'
import { roleObj } from '@/plugins/roles'
import GoodOrBad from './GoodOrBad.vue'
import Recommend from './Recommend.vue'

export default {
  name: "bank_rating",
  components: { Likes, ReteBlock, GoodOrBad, Recommend },
  data: () => ({
    roleObj,
    moment,
    sortComment: 1,
    sortVariant: [
      { id: 0, name: 'Сначала полезные' },
      { id: 1, name: 'Сначала новые' },
      // {id: 2, name: 'Сначала старые'},
    ],
    rate: null,
  }),
  props: {
    bankInfo: { type: Array, default: () => ([]) },
  },
  computed: {
    bank_id() {
      return this.$store.getters.get_bank_id ? this.$store.getters.get_bank_id : this.$route.query.bank_id
    },
    product_id() {
      return this.$store.getters.get_product_id ? this.$store.getters.get_product_id : this.$route.query.product_id
    },
    like() {
      return !this.likeIcon ? "fa-thumbs-up" : "fa-thumbs-o-up";
    },
    dislike() {
      return !this.dislikeIcon ? "fa-thumbs-up" : "fa-thumbs-o-up";
    },
    sortedBankInfo() {
      return this.bankInfo ? this.sortBank() : []
    }
  },
  methods: {
    removeBankRate(bank) {
      const obj = {
        bank_id: this.bank_id,
        product_id: this.product_id,
        user_id: bank.comment.user.id,
      }
      this.$store.dispatch('REMOVE_USER_RATE_FROM_BANK', obj)
      this.init()
    },
    sortBank() {
      if (this.sortComment == 0) {
        //sort by useful
        return Array.from(this.DeepCopy(this.bankInfo)).sort((a, b) => {
          if (a.comment.likes.useful > b.comment.likes.useful) {
            return -1;
          }
          if (a.comment.likes.useful < b.comment.likes.useful) {
            return 1;
          }
          // a должно быть равным b
          return 0;
        })
      } else if (this.sortComment == 1) {
        //sort by comment date newer
        return Array.from(this.DeepCopy(this.bankInfo)).sort((a, b) => {
          if (moment(a.date).unix() > moment(b.date).unix()) {
            return -1;
          }
          if (moment(a.date).unix() < moment(b.date).unix()) {
            return 1;
          }
          // a должно быть равным b
          return 0;
        })
      }
      /* else if(this.sortComment == 2){
        //sort by comment date older
        return Array.from(this.DeepCopy(this.bankInfo)).sort((a,b)=>{
          if (moment(a.date).unix() > moment(b.date).unix()) {
            return 1;
          }
          if (moment(a.date).unix() < moment(b.date).unix()) {
            return -1;
          }
          // a должно быть равным b
          return 0;
        })
      } */else {
        return this.bankInfo
      }
    },
    init() {
      this.$emit('init')
    }
  },
};
</script>
<style lang="sass" scoped>
.flex
  display: flex
  column-gap: 20px
.flex-center
  justify-content: center
.flex-align-center
  align-items: center
.textarea
  height: 115px !important
  overflow: scroll
.comment__block
  display: grid
  grid-template-columns: 1.5fr 3fr
  align-items: center
  grid-template-rows: 1fr
  grid-template-areas: 'rate comment'
  border-bottom: 1px solid #ccc
  font-size: 14px
  .rate
    grid-area: rate
    align-self: flex-start
    padding: 15px 20px
  .comment
    grid-area: comment
    align-self: end
    .v-textarea
      margin-top: 5px
      padding-top: 10px
      height: 130px
  .like__dislike
    padding: 5px
    grid-area: likeDislike
    display: flex
    column-gap: 20px
    justify-content: flex-end
.rates
  display: grid
  grid-template-columns: repeat(2, 1fr )
.rating_items
  display: flex
  justify-content: left
  align-items: center
.rate
  padding: 20px
</style>
